import * as types from './mutation-types';

export default {
  [types.SET_DISCOUNT_CONFIGURATION](state, payload) {
    state.discountConfig = payload;
  },
};
